import { render, staticRenderFns } from "./ed-create-file-object.vue?vue&type=template&id=42a5ebd3&"
import script from "./ed-create-file-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-file-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-file-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports